<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_toc_2"><span>The Way Beyond</span></h1>
<p class="P_Normal__And__Left_Indent">by Eliana West</p>
<p class="P_Normal"> </p>
<p class="P_Normal"><i>When she finds out his secret, will he lose her for good?</i></p>
<p class="P_Normal"> </p>
<p class="P_Normal">Jacob Winters has a secret: he’s come to Colton undercover as an FBI handler. He didn’t plan to stay, but the small town has charmed him with a sense of community that he hasn’t felt in a long time. And his attraction to the beautiful Mae Colton complicates things even more. Jacob doesn’t do relationships—he won’t risk making memories he might regret.</p>
<p class="P_Normal"> </p>
<p class="P_Normal">Mae Colton loves her little town of Colton, Mississippi, and doesn’t want to leave. In fact, instead of moving on to bigger things—namely a political career in DC like she’d planned—she wants to run for a second term as mayor of Colton. But not everyone in town supports this choice, including the commitment-phobic Jacob Winters.</p>
<p class="P_Normal"> </p>
<p class="P_Normal">Mae is ready to make their secret relationship official and go public, but that would break Jacob’s one rule. When a threat against Mae’s life forces him to admit the truth of his feelings, he has to race to save the woman he loves before it’s too late.</p>
<p class="P_Normal"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0002.vue?0cc07b14